import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=c773af80&scoped=true"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"
import style0 from "./Question.vue?vue&type=style&index=0&id=c773af80&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c773af80",
  null
  
)

export default component.exports